export const SUBMIT_PROCESS_STATEMENT_SUCCESS = 'SUBMIT_PROCESS_STATEMENT_SUCCESS';

export const submitProcessStatementSuccess = processStatement => ({
    type: SUBMIT_PROCESS_STATEMENT_SUCCESS,
    payload: { processStatement },
});
